import { render, staticRenderFns } from "./GroupMessagesTab.vue?vue&type=template&id=5e4c0236&scoped=true&"
import script from "./GroupMessagesTab.vue?vue&type=script&lang=js&"
export * from "./GroupMessagesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c0236",
  null
  
)

export default component.exports